/** Option lists for the lender additional questions form. Mirrors the Flex workscreen lists. */

export const occupationSectorOptions = [
  "Accountant/Actuary",
  "Agriculture, Forestry and Fishing",
  "Ambassador/ Diplomat",
  "Archaeologist / Historian",
  "Architect/Land/Property Developer/Landlord",
  "Armed Forces",
  "Art Dealer",
  "Auctioneer/Valuer",
  "Bailiff",
  "Catering & Hospitality",
  "Civil Servant",
  "Construction",
  "Customer services, Call centres",
  "Dealer in High Value Goods",
  "Debt Collection",
  "Dentist",
  "Doctor",
  "Education",
  "Engineering/Manufacturing",
  "Estate Agent",
  "Film/Television / Arts / Media",
  "Financial Services, Banking & Insurance",
  "Financial Trader",
  "Gambling/Betting",
  "Hairdresser/Barber/Beautician",
  "Health & Social Care",
  "Home Maker",
  "Independent Car dealer / Dealer in High Value Goods",
  "IT & Internet",
  "Jeweller / Pawnbroker",
  "Legal",
  "Letting Agent",
  "Management Consultancy",
  "Maritime/shipping",
  "Marketing, Advertising, PR",
  "Mechanic",
  "Office Worker (Secretarial, PA etc.)",
  "Oil, Gas, Alternative energy, Water",
  "Painting & Decorating",
  "Plumbing",
  "Politician",
  "Property Management",
  "Public Sector Services / Emergency Services",
  "Publican / pub landlord",
  "Religious",
  "Retail",
  "Retired",
  "Security",
  "Student",
  "Tax Advisory",
  "Taxi Driver",
  "Telecommunications",
  "Tradesperson",
  "Transport Operator",
  "Transport, Logistics (outside of the EU)",
  "Travel, Leisure, Tourism",
  "Undertaker",
  "Unemployed",
  "Vet",
  "Virtual Currencies",
];

export const vwfsOccupationSectorOptions = [
  "Dispatch rider",
  "Driver",
  "Executive",
  "Financial Consultant",
  "Foreman",
  "Guard",
  "Housewife",
  "Labourer, Outdoor worker",
  "Manager",
  "Military (enlisted; non-comm)",
  "Military Officer",
  "Not Classified",
  "Office Staff",
  "Ops Development Analyst",
  "Owner of Business (prof.)",
  "Owner of Business (non prof.)",
  "Part Time",
  "Production / Factory Worker",
  "Professional - Financial",
  "Professional - Legal",
  "Professional - Medical",
  "Professional - Other",
  "Retired",
  "Sales Indoor",
  "Sales outdoor",
  "Semi Professional - Financial",
  "Semi Professional - Legal",
  "Semi Professional - Medical",
  "Semi Professional - Other",
  "Service",
  "Social Worker",
  "Student",
  "Taxi Driver",
  "Trades (Building and Related)",
  "Unemployed",
];

export const existingLenderOptions = [
  "Moneybarn",
  "Motor247",
  "Oodle Car Finance",
  "Marsh Finance",
  "Moneyway",
  "Advantage Finance",
  "Specialist Motor Finance",
  "Startline Motor Finance",
  "Lendable",
  "CarFinance 247",
  "Alphera Financial Services",
  "Metro Bank",
  "BNP Paribas",
  "Mann Island Finance",
  "MotoNovo Finance",
  "V12 Vehicle Finance",
  "Blue Motor Finance",
  "Billing Finance",
  "RateSetter",
  "Close Brothers Motor Finance",
  "Auto Money Motor Finance",
  "Tandem Bank",
  "Zopa",
  "Credit Agricole",
  "Northridge Finance",
];

/** Sentinel used by the Existing Lender select when the agent types a lender not on the list. */
export const OTHER_LENDER_OPTION = "Other";

export const nationalityOptions = [
  "United Kingdom",
  "Afghanistan",
  "Albania",
  "Algeria",
  "Andorra",
  "Angola",
  "Anguilla",
  "Antarctica",
  "Antigua and Barbuda",
  "Argentina",
  "Armenia",
  "Aruba",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahamas",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bermuda",
  "Bhutan",
  "Bolivia",
  "Bosnia and Herzegovina",
  "Botswana",
  "Bouvet Island",
  "Brazil",
  "British Indian Ocean Territory",
  "Brunei Darussalam",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Cape Verde",
  "Cayman Islands",
  "Central African Republic",
  "Chad",
  "Chile",
  "China",
  "Christmas Island",
  "Cocos (Keeling) Islands",
  "Colombia",
  "Comoros",
  "Congo",
  "Congo, The Democratic Republic of the",
  "Cook Islands",
  "Costa Rica",
  "Cote d'Ivoire",
  "Croatia",
  "Cuba",
  "Cyprus",
  "Czech Republic",
  "Denmark",
  "Djibouti",
  "Dominica",
  "Dominican Republic",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "England",
  "England and Wales",
  "Equatorial Guinea",
  "Eritrea",
  "Estonia",
  "Ethiopia",
  "Falkland Islands (Malvinas)",
  "Faroe Islands",
  "Fiji",
  "Finland",
  "France",
  "French Guiana",
  "French Polynesia",
  "French Southern Territories",
  "Gabon",
  "Gambia",
  "Georgia",
  "Germany",
  "Ghana",
  "Gibraltar",
  "Greece",
  "Greenland",
  "Grenada",
  "Guadeloupe",
  "Guam",
  "Guatemala",
  "Guernsey",
  "Guinea",
  "Guinea-Bissau",
  "Guyana",
  "Haiti",
  "Heard Island and McDonald Islands",
  "Holy See (Vatican City State)",
  "Honduras",
  "Hong Kong",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Iran",
  "Iraq",
  "Ireland",
  "Isle of Man",
  "Israel",
  "Italy",
  "Jamaica",
  "Japan",
  "Jersey",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kiribati",
  "Korea, Democratic People's Republic of",
  "Korea, Republic of",
  "Kuwait",
  "Kyrgyzstan",
  "Lao People's Democratic Republic",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libyan Arab Jamahiriya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Macao",
  "Macedonia, The Former Yugoslav Republic of",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Marshall Islands",
  "Martinique",
  "Mauritania",
  "Mauritius",
  "Mayotte",
  "Mexico",
  "Micronesia, Federated States of",
  "Moldova, Republic of",
  "Monaco",
  "Mongolia",
  "Montenegro",
  "Montserrat",
  "Morocco",
  "Mozambique",
  "Myanmar",
  "Namibia",
  "Nauru",
  "Nepal",
  "Netherlands",
  "Netherlands Antilles",
  "New Caledonia",
  "New Zealand",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "Niue",
  "Norfolk Island",
  "Northern Mariana Islands",
  "Norway",
  "Oman",
  "Pakistan",
  "Palau",
  "Palestinian Territory, Occupied",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru",
  "Philippines",
  "Pitcairn",
  "Poland",
  "Portugal",
  "Puerto Rico",
  "Qatar",
  "Reunion",
  "Romania",
  "Russian Federation",
  "Rwanda",
  "Saint Barthelemy",
  "Saint Helena",
  "Saint Kitts and Nevis",
  "Saint Lucia",
  "Saint Martin",
  "Saint Pierre and Miquelon",
  "Saint Vincent and the Grenadines",
  "Samoa",
  "San Marino",
  "Sao Tome and Principe",
  "Saudi Arabia",
  "Scotland",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Slovakia",
  "Slovenia",
  "Solomon Islands",
  "Somalia",
  "South Africa",
  "South Georgia and the South Sandwich Islands",
  "Spain",
  "Sri Lanka",
  "Sudan",
  "Suriname",
  "Svalbard and Jan Mayen",
  "Swaziland",
  "Sweden",
  "Switzerland",
  "Syrian Arab Republic",
  "Taiwan, Province of China",
  "Tajikistan",
  "Tanzania, United Republic of",
  "Thailand",
  "Timor-Leste",
  "Togo",
  "Tokelau",
  "Tonga",
  "Trinidad and Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Turks and Caicos Islands",
  "Tuvalu",
  "Uganda",
  "Ukraine",
  "United Arab Emirates",
  "United States",
  "United States Minor Outlying Islands",
  "Uruguay",
  "Uzbekistan",
  "Vanuatu",
  "Venezuela",
  "Vietnam",
  "Virgin Islands, British",
  "Virgin Islands, U.S.",
  "Wales",
  "Wallis and Futuna",
  "Western Sahara",
  "Yemen",
  "Zambia",
  "Zimbabwe",
];

export const VWFS_DISCLAIMER =
  "*including Volkswagen Group Leasing, Audi Finance, Volkswagen Finance, Volkswagen Commercial Vehicle Finance, SEAT Finance, Skoda Finance, Cupra Finance, Bentley Financial Services and Porsche Financial Services";

export const VWFS_PRIVACY_POLICY_URL = "https://customer.vwfs.co.uk/privacy-policy.html";

/** Maximum shareholding / partnership company rows the agent may add. */
export const MAX_COMPANY_ROWS = 5;
